module.exports = __webpack_public_path__ + "static/media/sidebar-analytic.27f726a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-analytic.svg
// module id = 807
// module chunks = 0